import { defineAsyncComponent } from 'vue';
import HawkLoader from '~/common/components/atoms/hawk-loader.vue';
import PermissionDenied from '~/common/pages/permission-denied.vue';
import Inventory from '~/inventory/pages/inventory.vue';

const InventoryBOM = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-bom.vue'),
  loadingComponent: HawkLoader,
});
const InventoryDashboard = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-dashboard.vue'),
  loadingComponent: HawkLoader,
});
const InventoryItemForm = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-item-form.vue'),
  loadingComponent: HawkLoader,
});
const InventoryItems = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-items.vue'),
  loadingComponent: HawkLoader,
});
const InventoryReportForm = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-report-form.vue'),
  loadingComponent: HawkLoader,
});
const InventoryReports = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-reports.vue'),
  loadingComponent: HawkLoader,
});
const InventorySettings = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-settings.vue'),
  loadingComponent: HawkLoader,
});
const InventoryTransactionForm = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-transaction-form.vue'),
  loadingComponent: HawkLoader,
});
const InventoryTransactionTypeForm = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-transaction-type-form.vue'),
  loadingComponent: HawkLoader,
});
const InventoryTransactions = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-transactions.vue'),
  loadingComponent: HawkLoader,
});
const InventoryPurchaseOrderForm = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-purchase-order-form.vue'),
  loadingComponent: HawkLoader,
});
const InventoryWarehouseDetails = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-warehouse-details.vue'),
  loadingComponent: HawkLoader,
});
const InventoryWarehouses = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-warehouses.vue'),
  loadingComponent: HawkLoader,
});
const InventoryWorkOrders = defineAsyncComponent({
  loader: () => import('~/inventory/pages/inventory-work-orders.vue'),
  loadingComponent: HawkLoader,
});

const routes = [
  {
    path: '/:asset_id?/inventory/',
    name: 'inventory',
    redirect: { name: 'inventory-items' },
    component: Inventory,
    meta: {
      requireModuleAccess: 'inventory',
    },
    children: [
      {
        path: 'permission-denied',
        name: 'inventory-permission-denied',
        component: PermissionDenied,
      },
      {
        path: 'dashboard',
        component: InventoryDashboard,
        name: 'inventory-dashboard',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'items',
        component: InventoryItems,
        name: 'inventory-items',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'items/form/:item_id?',
        component: InventoryItemForm,
        name: 'inventory-item-form',
        meta: {
          module: 'inventory',
          parent: 'inventory-items',
        },
      },
      {
        path: 'warehouses',
        component: InventoryWarehouses,
        name: 'inventory-warehouses',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: ':warehouse_id?/warehouse-details',
        component: InventoryWarehouseDetails,
        name: 'inventory-warehouse-details',
        meta: {
          module: 'inventory',
          parent: 'inventory-warehouses',
        },
      },
      {
        path: 'purchase-orders',
        component: InventoryTransactions,
        name: 'inventory-purchase-orders',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'purchase-orders/form/:purchase_order_id?',
        component: InventoryPurchaseOrderForm,
        name: 'inventory-purchase-order-form',
        meta: {
          module: 'inventory',
          parent: 'inventory-purchase-orders',
        },
      },
      {
        path: 'work-orders',
        component: InventoryWorkOrders,
        name: 'inventory-work-orders',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'transactions',
        component: InventoryTransactions,
        name: 'inventory-transactions',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'transactions/:workflow_id?/transaction-form/:transaction_id?',
        component: InventoryTransactionForm,
        name: 'inventory-transaction-form',
        meta: {
          module: 'inventory',
          parent: 'inventory-transactions',
        },
      },
      {
        path: 'reports',
        component: InventoryReports,
        name: 'inventory-reports',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'report-forms',
        component: InventoryReportForm,
        name: 'inventory-report-form',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'bom',
        component: InventoryBOM,
        name: 'inventory-bom',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'settings',
        component: InventorySettings,
        name: 'inventory-settings',
        meta: {
          module: 'inventory',
        },
      },
      {
        path: 'settings/transaction-type/:transaction_type_uid?/',
        component: InventoryTransactionTypeForm,
        name: 'inventory-transaction-type',
        meta: {
          module: 'inventory',
          parent: 'inventory-settings',
        },
      },
    ],
  },

];
export default routes;
